'use client'

import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon
} from '@heroicons/react/24/outline'
import type { ComponentProps } from 'react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className='toaster group'
      position='bottom-right'
      style={{ zIndex: 999_999_999 }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg bg-backgroundPrimary',
          title: 'text-contentPrimary text-xl/7',
          description: '!text-contentSecondary text-base/6',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success:
            '!text-contentGreen !border-contentGreen !items-start !bg-backgroundPrimary !space-x-2',
          error:
            '!text-contentRed !border-contentRed !items-start !bg-backgroundPrimary !space-x-2',
          info: '!text-contentBlue !border-contentBlue !items-start !bg-backgroundPrimary !space-x-2'
        }
      }}
      duration={5000}
      icons={{
        success: <CheckCircleIcon className='mt-4 size-6 text-contentGreen' />,
        error: <ExclamationCircleIcon className='mt-4 size-6 text-contentRed' />,
        info: <InformationCircleIcon className='mt-4 size-6 text-contentBlue' />
      }}
      closeButton={false}
      {...props}
    />
  )
}

export { toast } from 'sonner'
export { Toaster }
